import { createContext, useContext, useState } from "react";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [password, setPassword] = useState("");
  const [userId, setUserId] = useState(null);
  const [salt, setSalt] = useState(null);

  return (
    <AuthContext.Provider value={{ password, setPassword, userId, setUserId, salt, setSalt }}>
      {children}
    </AuthContext.Provider>
  );
}

export function usePasswordAndUserId() {
  return useContext(AuthContext);
}